import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectEntityTypeValue } from '../../services/entityTypes/selectors';

interface Props {
    name?: string;
    plural?: boolean;
    pluralName?: string;
    children?: React.Element<any> | Function;
}

export class EntityTypeName extends React.PureComponent<Props> {
    get name() {
        const { name, plural, pluralName } = this.props;
        return plural ? pluralName : name;
    }

    render() {
        const { children } = this.props;

        if (typeof children === 'function') {
            return children(this.name);
        }

        if (children) {
            return React.cloneElement(children, {
                entityTypeName: this.name
            });
        }

        return this.name || null;
    }
}

const mapStateToProps = createStructuredSelector({
    name: makeSelectEntityTypeValue('name'),
    pluralName: makeSelectEntityTypeValue('pluralName')
});

// <State, Dispatch, OwnProps, StateProps, DispatchProps>
export default connect(mapStateToProps)(EntityTypeName);
